"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonScheduleModelsConverter = void 0;
const baseTypes_1 = require("../../core/baseTypes");
const types_1 = require("./types");
class CommonScheduleModelsConverter {
    static convertScheduleRowsToControlModel(value) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return {
            rowFirstScheduleValue: ((_a = value.rows.first) === null || _a === void 0 ? void 0 : _a.schedule) || [],
            isRowFirstScheduleEnabled: ((_b = value.rows.first) === null || _b === void 0 ? void 0 : _b.isEnabled) || false,
            rowFirstFieldCountValue: ((_c = value.rows.first) === null || _c === void 0 ? void 0 : _c.fields.count) || 0,
            rowFirstFieldTypeValue: ((_d = value.rows.first) === null || _d === void 0 ? void 0 : _d.fields.type) || baseTypes_1.RETENTION_TYPE.days,
            isRowFirstFieldTypeVisible: value.rows.first.fields.isTypeVisible || false,
            rowSecondScheduleValue: ((_e = value.rows.second) === null || _e === void 0 ? void 0 : _e.schedule) || [],
            isRowSecondScheduleEnabled: ((_f = value.rows.second) === null || _f === void 0 ? void 0 : _f.isEnabled) || false,
            rowSecondFieldCountValue: ((_g = value.rows.second) === null || _g === void 0 ? void 0 : _g.fields.count) || 0,
            rowSecondFieldTypeValue: ((_h = value.rows.second) === null || _h === void 0 ? void 0 : _h.fields.type) || baseTypes_1.RETENTION_TYPE.days,
            isRowSecondFieldTypeVisible: value.rows.second.fields.isTypeVisible || false,
            rowThirdScheduleValue: ((_j = value.rows.third) === null || _j === void 0 ? void 0 : _j.schedule) || [],
            isRowThirdScheduleEnabled: ((_k = value.rows.third) === null || _k === void 0 ? void 0 : _k.isEnabled) || false,
            rowThirdFieldCountValue: ((_l = value.rows.third) === null || _l === void 0 ? void 0 : _l.fields.count) || 0,
            rowThirdFieldTypeValue: ((_m = value.rows.third) === null || _m === void 0 ? void 0 : _m.fields.type) || baseTypes_1.RETENTION_TYPE.days,
            isRowThirdFieldTypeVisible: value.rows.third.fields.isTypeVisible || true,
        };
    }
    static convertScheduleRowsToMainModel(value, currentModelValue) {
        var _a, _b, _c;
        return {
            isEnabled: value.isEnabled,
            isModified: value.isModified,
            rows: {
                [types_1.SCHEDULE_ROW.first]: {
                    isEnabled: ((_a = currentModelValue.rows.first) === null || _a === void 0 ? void 0 : _a.isEnabled) || false,
                    schedule: value.rowFirstScheduleValue,
                    fields: {
                        count: value.rowFirstFieldCountValue,
                        type: value.rowFirstFieldTypeValue,
                        isTypeVisible: value.isRowFirstFieldTypeVisible,
                    },
                },
                [types_1.SCHEDULE_ROW.second]: {
                    isEnabled: ((_b = currentModelValue.rows.second) === null || _b === void 0 ? void 0 : _b.isEnabled) || false,
                    schedule: value.rowSecondScheduleValue,
                    fields: {
                        count: value.rowSecondFieldCountValue,
                        type: value.rowSecondFieldTypeValue,
                        isTypeVisible: value.isRowSecondFieldTypeVisible,
                    },
                },
                [types_1.SCHEDULE_ROW.third]: {
                    isEnabled: ((_c = currentModelValue.rows.third) === null || _c === void 0 ? void 0 : _c.isEnabled) || false,
                    schedule: value.rowThirdScheduleValue,
                    fields: {
                        count: value.rowThirdFieldCountValue,
                        type: value.rowThirdFieldTypeValue,
                        isTypeVisible: value.isRowThirdFieldTypeVisible,
                    },
                },
            },
        };
    }
}
exports.CommonScheduleModelsConverter = CommonScheduleModelsConverter;
//# sourceMappingURL=CommonScheduleModelsConverter.js.map